<template>
    <div>
        <div class="card mb-2">
			<div class="card-body pb-0">
				<div class="row">
					<div class="col-9 col-lg-9 mb-3">
						<label><i class="far fa-search font-13 color-theme mr-1 cursor-pointer"></i><span class="font-14">Procurar</span></label>
						<input title="Mobile" class="form-control rounded" placeholder="Digite aqui" type="text" v-model="valor"/>
						<input title="Desktop" class="form-control rounded" placeholder="Digite aqui" type="text" v-model="valor"/>
					</div>
					<div class="col-3 col-lg-1 align-self-end mb-3">
						<button class="btn btn-secondary w-100 rounded" @click="getEscola()">
							<i class="fa fa-search font-13"></i>
						</button>
					</div>
					<div class="col-12 col-lg-2 align-self-end mb-3">
						<button class="btn btn-secondary w-100 rounded" @click="abrirAdicionar()">
							<i class="fa fa-plus font-13 mr-1"></i> Adicionar
						</button>
					</div>
				</div>
			</div>
			<div class="d-flex justify-content-center mb-1 font-italic font-14">
				<span v-if="listaEscola.length == 1">{{listaEscola.length + ' resultado encontrado'}}</span>
				<span v-else-if="listaEscola.length > 1">{{listaEscola.length + ' resultados encontrados'}}</span>
			</div>
		</div> 

        <div v-if="listaEscola.length > 0">
            <div class="cards">
                <div v-for="(escola, index) in listaEscola" :key="index" :index="index" >
                    <div>
                        <div class="card d-flex p-3 font-16 mb-0 mt-0">
                            <div class="justify-content-center ">
                                <span class="unicoLimitador">
                                    <i class="fas fa-school mr-1 font-14 color-theme"></i><span class="font-16 font-weight-bold">{{escola.nome}}</span>
                                </span>
                                <span class="unicoLimitador">
                                    <i class="fas fa-map mr-1 font-14 color-theme"></i><span class="font-15">{{escola.endereco}}</span>
                                </span>
                            </div>
                            <div class="mt-3 d-flex justify-content-center">
                                <div class="mr-1">
                                    <button type="button" class="btn btnLogins-edit rounded " @click="editar(escola)"><span class="font-13">Editar</span></button>
                                </div>
                                <div class="ml-1">
                                    <button type="button" class="btn btnLogins-danger rounded" @click="excluir(escola.id, index)"><span class="font-13">Excluir</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-body mb-3 text-center font-16" v-else>Nenhuma informação encontrada</div>

        <!-- modal -->
        <div class="modal fade" id="modalEditarEscola" tabindex="-1" aria-labelledby="modalEditarEscolaLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title h4 color-theme"><span class="font-17" v-if="escolaEditar.id != null">Editar escola</span></h5>
                        <h5 class="modal-title h4 color-theme"><span class="font-17" else>Adicionar escola</span></h5>
                        <button type="button" class="close text-danger" data-dismiss="modal" aria-label="Close" @click="limparInputs()"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body mb-0">
                        <div class="row">
                        <div class="col-12 mb-3">
                            <label><i class="fas fa-school mr-1 font-14 color-theme"></i><span class="font-14"> Nome da escola: </span></label>
                            <input type="text" class="form-control required rounded" maxlength="200"  placeholder="Nome da escola" v-model="escolaEditar.nome"/>  
                        </div>
                        <div class="col-12 mb-3">
                            <label><i class="fas fa-map mr-1 font-14 color-theme"></i><span class="font-14"> Nome da cidade: </span></label>
                            <input type="email" class="form-control required rounded" maxlength="200"  placeholder="Nome da cidade" v-model="escolaEditar.endereco"/>  
                        </div>
                    </div>
                    </div>
                    <div class="modal-footer mb-0">
                        <button type="button" class="btn btnFechar rounded" data-dismiss="modal" @click="limparInputs()">Cancelar</button>
                        <button type="button" class="btn btn-secondary rounded" @click="salvar()">Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import { mapState } from 'vuex'
import $ from 'jquery'
import Swal from 'sweetalert2'

export default {
	name: 'EditarEscola',
    data() {
        return {
            listaEscola: [],
            valor: '',
            escolaEditar: {}
        };
    },
    computed: {
		... mapState({
			urlRest: state => state.urlRest
		})
    },
    methods: {
		salvar() {
			let ref = this;

			if(this.escolaEditar.nome == null || this.escolaEditar.nome == '') {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha o nome da escola' 
				})

				return
			} else if(this.escolaEditar.endereco == null || this.escolaEditar.endereco == '') {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha o nome da cidade'
				})

				return
			}

			this.$store.dispatch('alternarTelaCarregamento', true);
			this.$axios({
				method: 'post',
				url: this.urlRest +'service/addEscola ',
				headers: {
					'Content-Type': 'application/json'
				},

				data: this.escolaEditar
			}).then(function () {
				ref.$toast.fire({
					icon: 'success',
					title: 'Escola atualizada!',
					timer: 1500,
				})
				$('#modalEditarEscola').modal('hide')
				ref.getEscola()
			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						})
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					})
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false);
			});    
		},
        getEscola() {
            let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true);
            this.$axios({
                method: 'get',
                url: this.urlRest +'service/getEscola',
				params: {
					valor: this.valor
				},
                headers: {
                    'Content-Type': 'application/json'
                },

            }).then(response => {
				ref.listaEscola = response.data;

			}).catch(function (error) {
                if (error.response != undefined) {
                    if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                            icon: 'warning',
                            title: 'Sessão expirada!'
                        });
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: 'Erro: ' + error.response.status
                        })
                    }
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: error
                        })
                    }
                }).finally(() => {
                    this.$store.dispatch('alternarTelaCarregamento', false);
                });
                this.user 
        },
        editar(escola) {
            this.escolaEditar = JSON.parse(JSON.stringify(escola))
			$('#modalEditarEscola').modal('show')
		},
        excluir(id, index) {
			let ref = this;

			Swal.fire({
			icon: 'warning',
			title: 'Deseja excluir a escola?',
			confirmButtonText: 'Confirmar',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'

			}).then((result) => {
				if (result.isConfirmed) {

					this.$axios({
						method: 'post',
						url: this.urlRest + 'service/deletarEscola',
						params: {
							id: id,
						}
					}).then(() => {
						this.listaEscola.splice(index,1)
					})
					
				}
			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			})
		},
		abrirAdicionar() {
            this.escolaEditar = {}
			this.limparInputs()
			$('#modalEditarEscola').modal('show')
		},
		limparInputs() {
			this.escolaEditar.nome = null
			this.escolaEditar.endereco = null
			this.escolaEditar.id = null
		},
    },
	mounted() {
        this.getEscola()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkWindowSize);
    }
}
    
</script>

<style scoped>
    .text-icon {
        margin-top: 2.5px;
    }

   .switch input[type="checkbox"]:not(:checked) + .slider {
      background-color: #3c3e42
   }
   input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(50%);
   }
    .slide-up-enter-active {
        transition: all 0.4s;
    }

    .slide-up-enter {
        transform: translateY(-100%);
        opacity: 0;
    }

    .slide-up-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }

   .container_marker input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.container_marker {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  user-select: none;
  border-radius: 50%;
  background-color: rgb(78, 78, 78);
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 1em;
  width: 1em;
  transition: .3s;
  transform: scale(0);
  border-radius: 50%;
}

/* When the checkbox is checked, add a blue background */
.container_marker input:checked ~ .checkmark {
  background-color: #2096c5;
  transform: scale(1);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container_marker input:checked ~ .checkmark:after {
  display: block;
}

.container_marker input:checked ~ .celebrate {
  display: block;
}

/* Style the checkmark/indicator */
.container_marker .checkmark:after {
  left: 7px;
  top: 0.25em;
  width: 0.30em;
  height: 0.5em;
  border: solid rgb(255, 255, 255);
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}

.container_marker .celebrate {
  position: absolute;
  transform-origin: center;
  animation: kfr-celebrate .4s;
  animation-fill-mode: forwards;
  display: none;
  stroke: #0392CF;
}

@keyframes kfr-celebrate {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1.2);
    opacity: 0;
    display: none;
  }
}

.btnLogins-edit {
	font-weight: bold;
	color: #bebebe;
	border: solid 1px #bebebe;;
}

.btnLogins-edit:hover {
	background: #dfdfdf;
	color: #222427;
	font-weight: bold;
}

.btnLogins-danger {
	font-weight: bold;
	color: #bebebe;
	border: solid 1px #bebebe;
}

.btnLogins-danger:hover {
	border: solid 1px #fd4343;
	background: #fd4343;
	color: #222427;
	font-weight: bold;
}

.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}

.btnFechar {
	color: white;
	background-color: #616161;
}


</style>